import { reactive } from 'vue';
import type { FeaturesState } from './features-types';

const featuresState = reactive<FeaturesState>({
  features: {
    aiAssistantFull: false,
    dualDocumentModeFull: false,
    mathematicalValidationPreview: false,
  },
});

export default featuresState;
